module.exports = __webpack_public_path__ + "static/media/aisling.725a2655.svg";